// extracted by mini-css-extract-plugin
module.exports = {"ProductBigParagraph":"styles_ProductBigParagraph__RI2t9","title":"styles_title__ryuWf"};